import { Button, Text, HStack, Icon } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { fixedFeeTitle } from '../../constants';

import { FixedFeeHeaderProps } from '.';

export const FixedFeeHeaderMobile: React.FC<FixedFeeHeaderProps> = ({ hasSomeImpersonation }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  return (
    <HStack space="stack.xxxs" justifyContent="space-between" alignItems="center">
      <Text fontSize="lg" variant="semibold">
        {fixedFeeTitle}
      </Text>

      <Button
        variant="textLink"
        p={0}
        isDisabled={hasSomeImpersonation}
        onPress={() => navigate('FixedFeeNewContractModal')}
        rightIcon={<Icon name="PlusBigger" size="xxs" color="brand.tertiary.principal" />}>
        Nova contratação
      </Button>
    </HStack>
  );
};
